import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import PropTypes from 'prop-types'
import MyButton from '../../util/MyButton'
import ChatIcon from '@material-ui/icons/Chat'
import { connect } from 'react-redux';
import DeleteScream from './DeleteScream'
import ScreamDialog from './ScreamDialog'
import LikeButton from './LikeButton'

const styles = {
    card: {
        position: 'relative',
        display: " flex",
        marginBottom: 20
    },
    image: {
        minWidth: 100,
        minHeight: 100
    },
    content: {
        padding: 25,
        objectFit: 'cover'
    }
}

export class Scream extends Component {

    render() {
        dayjs.extend(relativeTime)
        const { classes, scream: { body, createdAt, userImage, userHandle, screamId, likeCount, commentCount },
            user: { authenticated, credentials: { handle } } } = this.props

        const deleteButton = authenticated && userHandle === handle ? (<DeleteScream screamId={screamId} />) : null
        return (
            <Card className={classes.card}>
                <CardMedia
                    image={userImage}
                    title="profile Image"
                    className={classes.image} />
                <CardContent className={classes.content}>
                    <Typography
                        variant='h5'
                        component={Link}
                        to={`/users/${userHandle}`}
                        color='primary'>
                        {userHandle}
                    </Typography>
                    {deleteButton}
                    <Typography
                        variant='body2'
                        color='textSecondary'>
                        {dayjs(createdAt).fromNow()}
                    </Typography>
                    <Typography variant='body1'>
                        {body}
                    </Typography>
                    <LikeButton screamId={screamId} authenticated={authenticated} />

                    <span>{likeCount}</span>
                    <MyButton tip='comments'>
                        <ChatIcon color='primary'></ChatIcon>
                    </MyButton>
                    <span>{commentCount}</span>
                    <ScreamDialog screamId={screamId} userHandle={userHandle} openDialog={this.props.openDialog} />
                </CardContent>
            </Card>
        )
    }
}

Scream.propTypes = {
    user: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
}

let mapStateToProps = state => ({
    user: state.user
})

export default connect(mapStateToProps, {})(withStyles(styles)(Scream))
